// import authApi from '../api/auth';

interface StorageValue {
    value: string,
    expire: number
}

const getToken = (key: string) => {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) return null;

    const item = JSON.parse(itemStr) as StorageValue;

    return item;
}

const customLocalStorage = {
    setWithExpire: (key: string, value: string, ttl: number) => {
        const now = new Date();

        const item = {
            value: value,
            expire: now.getTime() + (ttl * 1000)
        }
        localStorage.setItem(key, JSON.stringify(item));
    },
    // Get a token from local storage. If it's expired return null. If it's not expired and we haven't got a new token for the key try to get it
    getWithExpire: (key: string) => {
        const now = new Date();
        let item = getToken(key);
        let refreshToken = localStorage.getItem("REFRESH_TOKEN");

        if (!item && !refreshToken) {
            return null;
        }

        if (item && (now.getTime() < item.expire)) {
            return item.value;
        }
 
        // if (
        //     (!item && refreshToken) ||
        //     (refreshToken && item && (now.getTime() > item.expire))
        // ) {
        //     console.log("DEBUG: 1");
        //     // remove access_key
        //     localStorage.removeItem(key);

        //     // call refresh token api, this api will generate token and then set it to localStorage
        //     authApi.refreshToken()
        //         .then(() => {
        //             // get the new token again
        //             let item = getToken(key);
        //             if (item !== null && item !== undefined) {
        //                 return item.value;
        //             }
        //             return null;
        //         })
        //         .catch(err => console.error(err));
        // }

        return null;
    },
    getToken: getToken
}

export default customLocalStorage;